/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Manual_HintInputs */

const vi_carrier_manual_hint = /** @type {(inputs: Carrier_Manual_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập mã tỉnh và mã phường/xã của hãng vận chuyển để tiếp tục`)
};

/**

* @param {Carrier_Manual_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_manual_hint = /** @type {((inputs?: Carrier_Manual_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Manual_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_manual_hint(inputs)
});